import { InjectionToken } from '@angular/core';

export const DIALOG_DATA = new InjectionToken<object>('DIALOG_DATA');
